import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgError = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={57}
    height={56}
    viewBox='0 0 57 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M28.8662 17.5C28.8662 17.22 28.6462 17 28.3662 17C28.0862 17 27.8662 17.22 27.8662 17.5V34H28.8662V17.5Z'
      fill='#0A3680'
    />
    <path
      d='M28.3662 38.97C28.9185 38.97 29.3662 38.5223 29.3662 37.97C29.3662 37.4177 28.9185 36.97 28.3662 36.97C27.8139 36.97 27.3662 37.4177 27.3662 37.97C27.3662 38.5223 27.8139 38.97 28.3662 38.97Z'
      fill='#0A3680'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.36621 28C8.36621 16.97 17.3362 8 28.3662 8C39.3962 8 48.3662 16.97 48.3662 28C48.3662 39.03 39.3962 48 28.3662 48C17.3362 48 8.36621 39.03 8.36621 28ZM9.36621 28C9.36621 38.48 17.8862 47 28.3662 47C38.8462 47 47.3662 38.48 47.3662 28C47.3662 17.52 38.8462 9 28.3662 9C17.8862 9 9.36621 17.52 9.36621 28Z'
      fill='#0A3680'
    />
  </svg>
);
export default SvgError;
